<template>
  <div>
    <!-- Formulario de adicion de nodos -->
    <div id="formulario-nodos" style="width: 100%" align="center">
      <circle-loader ref="circleLoader" />

      <div v-if="!submitted">
        <!-- INIT FORMULARIO DE ADICION -->
        <b-form @submit="saveSensor" @reset="resetForm">
          <div class="groupBox">
            <b-row>
              <b-col>
                <p class="titulo1 text-center">Parámetros del sensor</p>
                <div class="groupBox" :style="(selectedType && selectedType != 'null') ? '' : 'max-width:600px'">
                  <!-- Fila 1 -->
                  <b-row>
                    <b-col align="left">
                      <b-form-group
                        label-size="sm"
                        label="Descripción dispositivo *"
                        label-for="description"
                      >
                        <b-form-input
                          size="sm"
                          id="description"
                          name="description"
                          placeholder="..."
                          v-model="sensor.description"
                          required
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Fila 5 -->
                  <b-row>
                    <b-col align="left">
                      <b-form-group
                        label-size="sm"
                        label="Asociar a un nodo"
                        label-for="devices"
                      >
                        <b-form-select
                          id="devices"
                          name="devices"
                          size="sm"
                          v-model="selectedDevice"
                          style="cursor: pointer"
                        >
                          <b-form-select-option value="null"
                            >Ningun nodo</b-form-select-option
                          >
                          <b-form-select-option
                            v-for="device in deviceList"
                            v-bind:key="device.alias"
                            v-bind:value="device"
                          >
                            {{ device.alias }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Fila 6 -->
                  <b-row>
                    <b-col>
                      <div
                        class="innergroupBox"
                        style="
                          padding: 15px 5px 5px 5px !important;
                          margin-bottom: 10px;
                          cursor: pointer;
                        "
                        v-if="selectedType && selectedType.shmCapable"
                      >
                        <b-row>
                          <b-form-group
                            class="form-check form-switch"
                            style="margin-left: 50px; cursor: pointer"
                          >
                            <input
                              class="form-check-input"
                              v-model="shmCheck"
                              type="checkbox"
                              id="switchSHM"
                              style="cursor: pointer"
                            />
                            <label class="form-check-label" for="switchSHM"
                              >Procesar medidas usando SHM</label
                            >
                          </b-form-group>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>


                  <!-- Fila 1 -->
                  <b-row>
                    <b-col align="left">
                      <b-form-group
                        label-size="sm"
                        label="Tipologia sensor"
                        label-for="type"
                      >
                        <b-form-select
                          size="sm"
                          id="tipologia"
                          name="tipologia"
                          v-model="selectedType"
                          style="cursor: pointer"
                        >
                          <b-form-select-option value="null"
                            >Tipo no seleccionado</b-form-select-option
                          >
                          <b-form-select-option
                            v-for="type in typeList"
                            v-bind:key="type.alias"
                            v-bind:value="type"
                          >
                            {{ type.alias }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Fila 2 -->
                  <b-row>
                    <b-col>
                      <div class="innergroupBox">
                        <b-row>
                          <b-col>
                            <center>
                              <img
                                v-if="selectedType && selectedType != 'null'"
                                style="height: 115px"
                                :src="getImgUrl(selectedType.image)"
                              />
                              <img
                                v-else
                                style="height: 115px"
                                :src="getImgUrl('default.svg')"
                              />
                            </center>
                          </b-col>
                          <b-col>
                            <p
                              v-if="selectedType && selectedType != 'null'"
                              v-html="selectedType.description"
                            ></p>
                            <p v-else>
                              Debe seleccionar un tipo para mostrar su
                              descripción
                            </p>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>


                  <!-- Fila 7 -->
                  <b-row>
                    <b-col align="left">
                      <small>* El campo debe ser rellenado</small><br />
                      <small
                        >** Utilice el valor 0 para no especificar el
                        intervalo</small
                      >
                    </b-col>
                  </b-row>


                </div>
              </b-col>

              <!--BLoque derechas -->
              <b-col v-if="selectedType && selectedType != 'null'">
                <b-row>
                  <b-col>
                    <p class="titulo1 text-center">
                      Personalizar la denominación de las medidas
                    </p>
                    <div
                      class="innergroupBox"
                      v-if="selectedType && selectedType != 'null'"
                    >
                      <div class="groupBox">
                        <b-row
                          v-for="(data, index) in dataFields"
                          :key="index"
                          class="innergroupBoxAlt"
                        >
                          <b-col>
                            <b-form-group
                              :label="
                                'Denominación de la medida \'' +
                                data.label +
                                '\''
                              "
                              label-size="sm"
                              :label-for="'denomination' + index"
                            >
                              <b-form-input
                                :id="'denomination' + index"
                                :name="'customColumnNames' + index"
                                size="sm"
                                placeholder="..."
                                v-model="sensor.customColumnNames[index]"
                                :value="sensor.customColumnNames[index]"
                              />

                              <div style="margin-left: 20px">
                                <input
                                  class="form-check-input"
                                  v-model="sensor.customColumnHide[index]"
                                  :input-value="sensor.customColumnHide[index]"
                                  type="checkbox"
                                  :id="'hideColumn' + index"
                                  style="cursor: pointer"
                                />
                                <label
                                  class="form-check-label"
                                  for="'hideColumn' + index"
                                  style="font-size: 0.8rem"
                                >
                                  Ocultar columna en tablas
                                </label>
                              </div>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>

                      <div class="groupBox mt-2" v-if="selectedType.alias == 'Pluviometro WS2080' || selectedType.alias == 'Contador Hidrojet 80H-20V'">

                        <b-row class="innergroupBoxAlt">
                          <b-col>
                            <b-form-group
                              label="Máximo incremento (mm)"
                              label-size="sm"
                              label-for="max-increment"
                              v-if="selectedType.alias == 'Pluviometro WS2080'"
                            >
                              <b-form-input
                                id="max-increment"
                                size="sm"
                                placeholder="..."
                                v-model="sensor.thresholds.maxIncrement"
                                :value="sensor.thresholds.maxIncrement"
                              />
                            </b-form-group>
                            <b-form-group
                              label="Máxima acumulación por chubasco (mm)"
                              label-size="sm"
                              label-for="max-shower-accumulation"
                              v-if="selectedType.alias == 'Pluviometro WS2080'"
                            >
                              <b-form-input
                                id="max-shower-accumulation"
                                size="sm"
                                placeholder="..."
                                v-model="sensor.thresholds.maxShowerAccumulation"
                                :value="sensor.thresholds.maxShowerAccumulation"
                              />
                              <div>
                                <p
                                  style="font-size: 0.8rem"
                                >
                                  Se realizará la comprobación sumando los {{ numberOfIncrementsPerShower }} incrementos anteriores
                                </p>
                              </div>
                            </b-form-group>
                            <b-form-group
                              label="Máximo consumo (L/s)"
                              label-size="sm"
                              label-for="max-consumption"
                              v-if="selectedType.alias == 'Contador Hidrojet 80H-20V'"
                            >
                              <b-form-input
                                id="max-consumption"
                                size="sm"
                                placeholder="..."
                                v-model="sensor.thresholds.maxConsumption"
                                :value="sensor.thresholds.maxConsumption"
                              />
                            </b-form-group>
                            <b-form-group
                              label="Máximo consumo acumulado (L/s)"
                              label-size="sm"
                              label-for="max-accumulated-consumption"
                              v-if="selectedType.alias == 'Contador Hidrojet 80H-20V'"
                            >
                              <b-form-input
                                id="max-accumulated-consumption"
                                size="sm"
                                placeholder="..."
                                v-model="sensor.thresholds.maxAcummulatedConsumption"
                                :value="sensor.thresholds.maxAcummulatedConsumption"
                              />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <!-- FIn filas -->
              </b-col>
            </b-row>

            <b-row style="margin-top:20px">
              <b-col>
                <b-form-group label-for="adduser">
                  <b-button
                    block
                    type="submit"
                    name="addnode"
                    id="addnode"
                    size="sm"
                    variant="primary"
                  >
                    <i class="fas fa-edit"></i>
                    <span
                      class="text-uppercase"
                      style="font-size: 12px;font-weight: bold;margin-left: 5px;"
                      >Agregar sensor</span
                    >
                  </b-button>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label-for="exitform">
                  <b-button
                    block
                    name="exitform"
                    id="exitform"
                    variant="danger"
                    size="sm"
                    @click="exitForm"
                  >
                    <i class="fas fa-arrow-left"></i>
                    <span
                      class="text-uppercase"
                      style="font-size: 12px;font-weight: bold;margin-left: 5px;"
                      >Salir de la edicion</span
                    >
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-form>
        <!-- END FORMULARIO DE ADICION -->
      </div>
      <!-- END V if submitted-->
    </div>
  </div>
</template>


<script>
//https://codepen.io/ne0/pen/MJXwOr to loader div
import SensorService from "@/services/SensorService";
import DeviceService from "@/services/DeviceService";
import CircleLoader from "@/components/common/CircleLoader";
import Vue from 'vue';


export default {
  name: "add-sensor",
  data() {
    return {
      sensor: {
        device: 0,
        datagram_interval: 0,
        image: "",
        description: "",
        customColumnNames: [],
        customColumnHide: [],
        thresholds: {
          maxIncrement: null,
          maxShowerAccumulation: null,
          maxConsumption: null,
          maxAcummulatedConsumption: null
        }
      },
      deviceList: [],
      selectedDevice: null,
      shmCheck: false,
      typeList: [],
      selectedType: null,
      submitted: false,
      dataFields: null,
      numberOfIncrementsPerShower: 20
    };
  },

  components: {
    "circle-loader": CircleLoader,
  },

  watch: {
    selectedType() {
      let fields = eval("(" + this.selectedType.columns + ")");
      fields = fields.slice(2, fields.length);
      //console.log(this.selectedType);
      this.dataFields = fields;
    },
  },

  methods: {
    retrieveDevice() {
      DeviceService.getAll()
        .then((response) => {
          this.deviceList = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveType() {
      SensorService.getAllTypes()
        .then((response) => {
          this.typeList = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    saveSensor(e) {
      e.preventDefault();
      var data;
      //var self = this; // assign context to self variable - extremely important

      this.$refs.circleLoader.reset();

      if (!this.selectedDevice || !this.selectedDevice.alias || this.selectedDevice == 'null') {
        data = {
          device: null,
          datagram_interval: this.sensor.datagram_interval
            ? this.sensor.datagram_interval
            : 0,
          description: this.sensor.description,
        };
      } else {
        data = {
          device: this.selectedDevice,
          datagram_interval: this.sensor.datagram_interval
            ? this.sensor.datagram_interval
            : 0,
          description: this.sensor.description,
        };
      }

      if (!this.selectedType) {
        data.type = null;
      } else {
        data.type = this.selectedType;
      }
      if (this.selectedType.shmCapable) {
        data.isShm = this.shmCheck;
      } else {
        data.isShm = false;
      }
      data.customColumnNames = this.sensor.customColumnNames;
      data.customColumnHide = this.sensor.customColumnHide;

      if(this.selectedType.alias == 'Pluviometro WS2080' || this.selectedType.alias == 'Contador Hidrojet 80H-20V'){
        data.thresholds = this.selectedType.alias == 'Pluviometro WS2080'
          ? JSON.stringify({
              maxIncrement: this.sensor.thresholds.maxIncrement,
              maxShowerAccumulation: this.sensor.thresholds.maxShowerAccumulation
            }) 
          : JSON.stringify({
              maxConsumption: this.sensor.thresholds.maxConsumption,
              maxAcummulatedConsumption: this.sensor.thresholds.maxAcummulatedConsumption
            });
      }

      SensorService.create(data)
        .then((response) => {
          //Mensaje de confirmacion
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: response.data.message
              ? response.data.message
              : "Sensor agregado correctamente",
            text: response.data.message
              ? ""
              : "Se ha agregado 1 nuevo sensor a la lista",
            duration: 3000,
            speed: 1000,
          });

          //Completar imagen y descargar div
          //Ocultamos el formulario
          this.submitted = true;
          this.$refs.circleLoader.showLoading("Registrando sensor ...");

          //Mostramos durante 2 segundos que se está gaurdando
          setTimeout(() => {
            //Checkar cabeceras e vuelta para cargar la X o el tick
            if (!response.data.message) {
              this.$refs.circleLoader.showEndError(
                "No se ha podido registrar el sensor"
              );
            } else {
              this.$refs.circleLoader.showEndSuccess(
                "Sensor almacenado correctamente"
              );
            }
            //Temporizador antes de mostrar de nuevo el formulario
            setTimeout(() => {
              this.submitted = false;
              //Emit event to notify parent to notify the other component
              this.$emit("onClickSave");
              //Remove form data
              this.resetValues();
            }, 1500);
          }, 2500);
        })
        .catch((e) => {
          console.log(e);
          //Mensaje de confirmacion
          this.$notify({
            group: "notificateDiv",
            type: "success",
            title: "Error al agregar el sensor",
            text: e.response.data.message
              ? e.response.data.message
              : e.response.data.error,
            duration: 3000,
            speed: 1000,
          });
          //Default message

          this.$refs.circleLoader.reset();
        });
    },

    exitForm() {
      this.$emit("onClickExit");
    },

    resetForm(evt) {
      evt.preventDefault();
      //Reset values from the form
      this.resetValues();
      //Mensaje de confirmacion
      this.$notify({
        group: "notificateDiv",
        type: "success",
        title: "Formulario reseteado",
        text: "Se han reestablecido los parámetros a sus valores iniciales",
        duration: 3000,
        speed: 1000,
      });
    },

    resetValues() {
      // Reset our form values
      this.sensor = {
        device: 0,
        datagram_interval: 0,
        image: "",
        description: "",
        customColumnNames: [],
        customColumnHide: [],
        isShm: false,
      };

      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    getImgUrl(image) {
      return require("@/assets/images/" + image);
    },
  },
  mounted() {
    this.retrieveDevice();
    this.retrieveType();

    //Para que no de el coñazo
    Vue.config.silent = true;
  },
};
</script>

<style scoped>
.groupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 30px;
}

.innergroupBox {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 20px;
}

.innergroupBoxAlt {
  border: 1px solid rgba(0, 0, 0, 0.0625);
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 10px;
}

.titulo1 {
  font-size: 0.95rem;
  color: #606266;
  text-align: center;
  font-weight: 400;
}
</style>
